<template>
    <div class="el-main-wrapper">
        <el-row class="el-title-block">
            <h1 class="el-title-with-icon">
                {{ $t('navigation.waitingAreas') }}
                <span v-if="selectedContainer">
                    : {{ selectedContainer.Description }}
                </span>
            </h1>
        </el-row>

        <div class="el-main-content">
            <stc-create-waiting-areas
                v-if="permissions.includes('WAITINGAREA_WRITE')"
                :associatedCheckpoints="associatedCheckpoints"
            ></stc-create-waiting-areas>
            <stc-waiting-areas-list
                v-if="associatedCheckpoints && associatedCheckpoints.length > 0"
                :associatedCheckpoints="associatedCheckpoints"
            ></stc-waiting-areas-list>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CreateWaitingAreasVue from '../../components/waiting-areas/CreateWaitingAreas.vue'
import WaitingAreasListVue from '../../components/waiting-areas/WaitingAreasList.vue'

export default {
    name: 'waiting-areas',

    components: {
        'stc-waiting-areas-list': WaitingAreasListVue,
        'stc-create-waiting-areas': CreateWaitingAreasVue,
    },

    computed: mapGetters(['permissions', 'selectedContainer']),

    data() {
        return {
            associatedCheckpoints: [],
        }
    },

    async created() {
        await this.fetchCheckpoints()
    },

    methods: {
        async fetchCheckpoints(container = null) {
            container = container || this.selectedContainer

            if (container) {
                let { data } = await this.$http.get(
                    `Container/${container.ContainerID}/Checkpoint`
                )
                data.sort((a, b) => {
                    if (a && b && a.Name && b.Name) {
                        return a.Name.localeCompare(b.Name, 'en', {
                            numeric: true,
                        })
                    }
                })
                this.associatedCheckpoints = data
            }
        },
    },
}
</script>
